import { render, staticRenderFns } from "./SupplierManageList.vue?vue&type=template&id=6c5c4c9a&scoped=true&"
import script from "./SupplierManageList.vue?vue&type=script&lang=js&"
export * from "./SupplierManageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5c4c9a",
  null
  
)

export default component.exports